<template>
    <i class="ni ni-paper-diploma text-dark" aria-hidden="true"></i>
</template>
<script></script>